import { AfterViewChecked, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, debounceTime, Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { ManageSlotComponent } from '../manage-slot/manage-slot.component';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


export function modifyTitle(arr: Array<Partial<TEXT_FIELDS>>, isFree: boolean = false) {
  const tempArr = [...arr];
  return isFree ?
    tempArr.filter(x => x.key != "FEATURED_PLAN" && x.key != "planAccessStatus") :
    tempArr;
}


@Component({
  selector: 'app-customer-jobs',
  standalone: true,
  imports: [CommonModule, NgxDatatableModule,
PlanCardComponent, CustomerSearchComponent, ManageSlotComponent, MtaFilterPipe, TimezoneDatePipe, TitleCasePipe, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-jobs.component.html',
  styleUrls: ['./customer-jobs.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerJobsComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {
  PLANMAX: number = 0;
  AVAILABLE: number = 0;
  ALLOCATED: number = 0;
  textFields: Array<Partial<TEXT_FIELDS>>;
  @ViewChild('sortTable') table: any;
  public listToShow: Array<any> = [];
  userPayload: any = {
    limit: 10,
    page: 0,
    statusList: null,
    groupType: "LISTING"
  }
  activate = new EventEmitter();
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  slotPayload: any = {
    type: "JOB_CANDIDATE_POSTINGS",
    limit: 10,
    page: 0,
    searchAfterKey: null,
    statusList: ["ACTIVE", "INACTIVE", "BLOCKED"],
    groupType: "MANAGE"
  }
  openSlotSubscription: Subscription;
  prevSearchAfterKey: any;
  stopScroll: boolean = false;
  scroll: boolean = false;
  public slotData = new BehaviorSubject([]);
  slotModalOpen: boolean = false;
  slotPlanDetails: any = {};
  businessData: any;
  allocationCards = [
    {
      id: "SLOT_MAX",
      name: "Slot Max",
      value: 0
    },
    {
      id: "SLOT_ALLOCATED",
      name: "Slot Used",
      value: 0
    },
    {
      id: "FEATURED_MAX",
      name: "Featured Max",
      value: 0
    },
    {
      id: "FEATURED_ALLOCATED",
      name: "Featured Used",
      value: 0
    },
  ];
  slotAllocatedCards = [];
  role: any
  MemberShipType: any;
  editMode: boolean = false;
  constructor(
    private router: Router,
    private _activated_route: ActivatedRoute,
    private _api_service: ApiService,
    public util: UtilService,
    private excel: ExcelService,
    private customerService: CustomerService,
    private modalService: BsModalService,
    private gigsumoService: GigsumoService,
    private renderer: Renderer2, private el: ElementRef,
  ) {
    super();

    this._activated_route.parent.data.subscribe(res => {
      this.businessData = res.data;
      this.role = this.businessData.role;
      this.MemberShipType = this.businessData.plan
      this.slotPayload.businessId = this.businessData.id;
      this.slotPayload.email = this.businessData.businessEmail;
    });

    this.textFields = [
      { label: "User Name", key: "fullName", value: null, type: "STRING" },
      { label: "Email ID", key: "username", value: null, type: "STRING" },
      { label: "Gigsumo ID", key: "gigsumoNo", value: null, type: "STRING" },
      { label: "Role", key: "userType", value: null, type: "STRING" },
      { label: "Slots Allowed", key: "SLOT_PLAN", value: null, type: "STRING" },
      { label: "Slots Used", key: "SLOT_PLAN", value: null, type: "STRING" },
      { label: "Featured Allowed", key: "FEATURED_PLAN", value: null, type: "STRING" },
      { label: "Featured Used", key: "FEATURED_PLAN", value: null, type: "STRING" },
      { label: "Start Date", key: "createdOn", value: null, type: "DATE" },
      { label: "Last Active", key: "lastLoggedIn", value: null, type: "DATE" },
      { label: "Plan Access", key: "planAccessStatus", value: null, type: "STRING" },
      { label: "Status", key: "userStatus", value: null, type: "STRING" },
    ];

    this.refreshSubcription = this.customerService.getRefreshKey().subscribe((ress: any) => {
      if (ress === "jobs") {
        this.ngOnInit();
      }
    });

    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'jobs') {
        this.userPayload.page = 0;
        this.userPayload.enabled = res.value.enabled;
        this.userPayload.statusList = res.value.status != null ? [res.value.status] : null;
        this.userPayload.roleList = res.value.role != null ? [res.value.role] : null;
        this.userPayload.planAccessStatus = res.value.planAccessStatus != null ? [res.value.planAccessStatus] : null;
        this.userPayload.searchContent = null;
        if (res.value.status == null) {
          this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"]
        }
        this.customerService.setFilterPayload(this.userPayload);
        this.fetchData();
      }
    });


    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "jobs") {
        this.userPayload.page = 0;
        this.userPayload.searchContent = response.value;

        if (response.value.status == null) {
          this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"]
        }

        this.fetchData();
      }
    });

    this.openSlotSubscription = this.customerService.getSlotModal().subscribe(res => {
      if (res.key === "jobs") {
        if (res.value.status == null) {
          this.userPayload.statusList = ["ACTIVE"];
        }
        this.slotPlanDetails = res.value;
        console.log("slot PLan", this.slotPlanDetails);

        this.editMode = false;
        this.fetchSlotData();
      }
    });

  }
  onSort(event) {
    const currentPage = this.userPayload.page;
    this.table.offset = currentPage;
  }

  ngOnInit(): void {
    if (this.MemberShipType === GigsumoConstants.FREE_PLAN) {
      const length = this.allocationCards.length;
      this.allocationCards.splice(length - 1, 1);
      this.allocationCards.splice(length - 2, 1);
    }

    this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"];
    this.fetchData();
  }

  scrollSynced = false; // Flag to prevent multiple bindings
  bodyScrollUnlistener: () => void; // To store the unlistener for clean-up
  resizeUnlistener: () => void; // To store resize unlistener

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    if (this.openSlotSubscription) {
      this.openSlotSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }
    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }

  nextPage(data: any) {
    this.userPayload.page = data.offset;
    if (this.userPayload.page == 0) {
      this.userPayload.page = 0;
    }
    this.userPayload.limit = 10;
    this.fetchData();
  }

  public selected = [];
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getCustomerUsersList(payload: Object): Observable<any> {
    return this._api_service.create('subscription/findEmployeeBenefitsAllocation', payload);
  }

  getjoballocationlist(payload: Object): Observable<any> {
    return this._api_service.create('subscription/findUserWithBenefitAllocation', payload);
  }

  totalUsers: number = 0;

  fetchData() {
    this.util.startLoader();
    const isSuperAdmin = this.role === 'SUPERADMIN' && ['Starter', 'Growth', 'ScaleX'].includes(this.MemberShipType);

    if (isSuperAdmin) {
      this.prepareSuperAdminPayload();
      this.fetchCustomerUsers();
    } else {
      this.prepareUserPayload();
      this.fetchJobAllocation();
    }
  }

  private prepareSuperAdminPayload() {
    this.userPayload.businessId = this.businessData.id;
    this.userPayload.email = this.businessData.email;
    this.userPayload.type = "JOB_CANDIDATE_POSTINGS";
  }

  private prepareUserPayload() {
    this.userPayload.userId = localStorage.getItem('userId');
    this.userPayload.type = "JOB_CANDIDATE_POSTINGS";
  }

  private fetchCustomerUsers() {
    this.getCustomerUsersList(this.userPayload).subscribe({
      next: (res) => this.handleResponse(res, true),
      error: (error) => this.handleError(error)
    });
  }

  private fetchJobAllocation() {
    this.getjoballocationlist(this.userPayload).subscribe({
      next: (res) => this.handleResponse(res, false),
      error: (error) => this.handleError(error)
    });
  }

  private handleResponse(res: any, isSuperAdmin: boolean) {
    this.util.stopLoader();
    if (res && res.code === "00000") {
      if (isSuperAdmin) {
        this.listToShow = res.data.customerUserAllocationList;
        this.totalUsers = res.data.totalUsers;
      } else {
        this.listToShow = Array.isArray(res.data.userWithBenefit) ? res.data.userWithBenefit : [res.data.userWithBenefit];
        this.totalUsers = 1;
      }
      if (this.listToShow) {
        this.listToShow.forEach(x => {
          x.userType = x.userType && x.userType.replaceAll("_", " ");
          //     x.userType = (x.userType === GigsumoConstants.MTA || x.userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION) ? GigsumoConstants.MANAGER : x.userType;
        })
      }

      this.excel.setCount(this.totalUsers);
      this.customerService.setUserData(this.listToShow);
      this.updatePlanDetails(res, isSuperAdmin);
    }
  }

  private updatePlanDetails(res: any, isSuperAdmin: boolean) {
    const plan = isSuperAdmin ? res.data.customerPlanUsage : res.data.userWithBenefit;
    if (plan) {
      // if (isSuperAdmin) {
      const slotPlan = plan.benefitsUsages?.find(x => (x.benefitKey as BENEFITS_KEY) === 'JOB_CANDIDATE_POSTINGS');
      const featuredPlan = plan.benefitsUsages?.find(x => (x.benefitKey as BENEFITS_KEY) === 'JOBS_CANDIDATE_SPOTLIGHTS');
      if (slotPlan) {
        this.PLANMAX = slotPlan.actual;
        this.AVAILABLE = slotPlan.available;
        this.ALLOCATED = slotPlan.utilized;
      }

      if (featuredPlan) {
        this.allocationCards[2].value = featuredPlan.actual;
        this.allocationCards[3].value = featuredPlan.utilized;
      }

      // } else {
      //   if (plan.benefitsUsages) {
      //     this.PLANMAX = plan.benefitsUsageAndBalance.actual;
      //     this.AVAILABLE = plan.benefitsUsageAndBalance.available;
      //     this.ALLOCATED = plan.benefitsUsageAndBalance.actual;
      //   }
      // }
      this.allocationCards[0].value = this.PLANMAX;
      this.allocationCards[1].value = this.ALLOCATED;
      this.slotAllocatedCards = structuredClone(this.allocationCards);
    }
  }

  private handleError(error: any) {
    this.util.stopLoader();
    console.error('Subscribe Error:', error); // Log any error in the subscribe block
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred while fetching data. Please try again later.",
    });
  }

  convertToTitleCase(str) {
    return str
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  fetchSlotData() {
    this.util.startLoader();
    this.getCustomerUsersList(this.slotPayload)
      .subscribe({
        next: (response) => {
          this.util.stopLoader();
          if (response && response.code === GigsumoConstants.SUCESSCODE) {

            const users = response.data.customerUserAllocationList ?? [];
            const searchKey = response.data.searchAfterKey;

            if (users) {
              const current = users;
              const exist = this.slotData.getValue();
              // let sortDuplicates = this.gigsumoService.removeDuplicatesKey([...exist, ...current] ,  'userId');
              this.slotData.next([...exist, ...current]);
            }

            if (users != null && (users.length === 0 || JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))) {
              this.stopScroll = true;
            }

            this.prevSearchAfterKey = searchKey;
            this.slotModalOpen = true;

          }
        },
        error: (error) => {
          console.error('Subscribe Error:', error); // Log any error in the subscribe block
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching data. Please try again later.",
          });
        }
      });
  }

  handleInvalidSession() {
    Swal.fire({
      icon: "info",
      title: "Invalid session",
      text: "Sorry, your session has expired. We are routing you to login page.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      this.util.stopLoader();
      Swal.close();
    });
  }


  openViewModal(datas: any) {

    this.textFields = modifyTitle(this.textFields, this.MemberShipType === "Free" ? true : false);


    if (datas) {
      Object.keys(datas).map(key => {
        this.textFields.forEach(v => {

          if (v.key === "SLOT_PLAN" || v.key === "FEATURED_PLAN") {
            const beneFitKey: BENEFITS_KEY = v.key === "FEATURED_PLAN" ? "JOBS_CANDIDATE_SPOTLIGHTS" : "JOB_CANDIDATE_POSTINGS";

            v.value = (datas.benefitsUsages ?? []).find(x =>
              (x.benefitKey as BENEFITS_KEY) === beneFitKey)[
              v.label.includes("Used") ? "utilized" : "actual"];
            return;
          }

          if (v.label === "Allocated" || v.label === 'Available') {
            v.value = this.curryObject(datas, 'benefitsUsageAndBalance')(v.label === "Allocated" ? "actual" : "available");
            return;
          }

          if (v.key === "planAccessStatus") {
            v.value = datas[v.key] === "ACTIVE" ? "Given" : "Not given";
            return;
          }

          if (v.key === "userType") {
            v.value = datas[v.key] ? this.util.userAlias(datas[v.key]) : "N/A";
            return;
          }


          if (v.key == key) {
            v.value = datas[key];
          }

        });
      });
    }


    if (this.textFields) {
      this.openView("Job/Candidate Slots", this.textFields, this.modalService, this.util);
    }

  }

  async openEditModal(row) {
    this.util.startLoader();
    let planData = await this.customerService.getupdatedplans(this.businessData.id);
    this.slotPlanDetails = planData
    console.log(row);
    this.slotData.next([row]);
    this.slotModalOpen = true;
    this.editMode = true;
    this.util.stopLoader();
  }

  onScroll() {
    if (!this.stopScroll) {
      this.slotPayload = {
        ...this.slotPayload,
        searchAfterKey: this.prevSearchAfterKey
      }
      this.fetchSlotData();
    }
  }

  onClose(d) {
    this.resetSlotData()
  }

  onSucess(d) {
    if (d === "SUCCESS") {
      this.resetSlotData()
    }
  }

  onSearch(v) {
    this.slotData.next([]);
    this.slotPayload.searchAfterKey = null;
    this.prevSearchAfterKey = null;
    this.stopScroll = false;
    this.slotPayload.searchContent = v;
    this.fetchSlotData();
  }

  resetSlotData() {
    this.slotData.next([]);
    this.slotPayload.searchAfterKey = null;
    this.prevSearchAfterKey = null;
    this.slotPayload.searchContent = "";
    this.slotModalOpen = false;
    this.editMode = false;
    this.stopScroll = false;
  }

  getPlanBenfits(data, KEY) {
    return data.benefitsUsages.find(x => x.benefitKey === KEY);
  }
}
